const TYPES = require('reducers/targetedPromotion').ACTION_TYPES;

function updateTargetedPromotion(data) {
    return {
        type: TYPES.UPDATE_TARGETED_PROMOTIOM,
        data: data
    };
}

module.exports = {
    TYPES,
    updateTargetedPromotion
};
